import React from "react";
import SensorLifeBar from "src/components/app/cgm/SensorLifeBar";

interface CGMStatusCardTemplateProps {
  image: any;
  color: string;
  bgColor?: string;
  label: string;
  description: string | React.ReactNode;
  sensorStartDate?: string | null;
  sensorEndDate?: string | null;
  bottomContent?: React.ReactNode;
}
const CGMStatusCardTemplate: React.FC<CGMStatusCardTemplateProps> = ({
  image,
  color,
  bgColor,
  label,
  description,
  sensorStartDate,
  sensorEndDate,
  bottomContent,
}) => {
  return (
    <div className="space-y-5 p-4">
      <img
        src={image}
        alt="CGM Status Image"
        className="w-auto h-[180px] object-contain mx-auto -mb-5"
      />
      <div
        className="rounded-2xl p-4 w-full"
        style={{
          //   backgroundColor: bgColor,
          background: `linear-gradient(to bottom, ${bgColor} 0%, #ffffff 40%, #ffffff 100%)`,
          border: `1px solid ${color}`,
        }}
      >
        <span
          className="text-xs font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full"
          style={{
            backgroundColor: color + "20",
            color: color,
          }}
        >
          {label}
        </span>
        <div className="mt-2">{description}</div>
      </div>

      {sensorStartDate && sensorEndDate && (
        <SensorLifeBar startDate={sensorStartDate} endDate={sensorEndDate} />
      )}

      {bottomContent && <div className="mx-auto">{bottomContent}</div>}
    </div>
  );
};

export default CGMStatusCardTemplate;
